import React from 'react';

import { NavItem } from './environments';

/**
 * Sidebar items for the operations console, from the redesign prototype.
 *
 * The icons are the prototype's emoji rather than svg paths — that is how the
 * operations rail is drawn, and substituting line icons would be redesigning
 * it rather than porting it.
 *
 * The count badges are dropped. Every one of them reads `0` in the prototype,
 * which is placeholder text; rendering it here would put a number on screen
 * that no queue produced, and an ops console whose counts are decorative is
 * worse than one with none.
 *
 * Source: docs/redesign/IQMaxx/4_Admin_Operaciones.html
 */

export const ADMIN_NAV: NavItem[] = [
  {
    key: 'today',
    label: 'Mis colas',
    to: '/admin/cases',
    group: 'Today',
    icon: <span className="ic">⏳</span>,
  },
  {
    // The PI-3 risk surface, which is a different screen from the queue: it
    // lists conditions the platform detected, where the queue lists work an
    // operator owns. Both earn a rail entry; conflating them cost the queue
    // its own route until now.
    key: 'risk',
    label: 'Riesgo operativo',
    to: '/admin/dashboard/ops',
    icon: <span className="ic">📉</span>,
  },
  {
    key: 'chain',
    label: 'Trust Chain',
    to: '/admin/chain',
    group: 'Modules',
    icon: <span className="ic">🔗</span>,
  },
  {
    // UC-A03 — the session → evidence → progress → release chain, its holds
    // and evidence requests, and class health.
    key: 'integrity',
    label: 'Integridad',
    to: '/admin/integrity',
    icon: <span className="ic">🧾</span>,
  },
  {
    key: 'payments',
    label: 'Payments & escrow',
    to: '/admin/payout-status',
    icon: <span className="ic">💰</span>,
  },
  {
    key: 'coverage',
    label: 'Coverage',
    to: '/admin/coverage',
    icon: <span className="ic">🧭</span>,
  },
  {
    key: 'quality',
    label: 'Learning quality',
    to: '/admin/dashboard/health',
    icon: <span className="ic">📈</span>,
  },
  {
    key: 'teachers',
    label: 'Teachers',
    to: '/admin/teacher-applications',
    icon: <span className="ic">🏫</span>,
  },
  {
    key: 'families',
    label: 'Families',
    to: '/admin/families',
    icon: <span className="ic">👪</span>,
  },
  {
    key: 'safety',
    label: 'Safety',
    to: '/admin/safety',
    icon: <span className="ic">🛡</span>,
  },
  {
    key: 'audit',
    label: 'Auditoría',
    to: '/admin/audit',
    group: 'Reference',
    icon: <span className="ic">📜</span>,
  },
  {
    key: 'playbook',
    label: 'Playbooks',
    to: '/admin/playbook',
    icon: <span className="ic">📖</span>,
  },
  {
    key: 'finance',
    label: 'Finance & BI',
    to: '/admin/dashboard/earnings',
    group: 'Not yet built',
    icon: <span className="ic">💰</span>,
  },
  {
    key: 'cohorts',
    label: 'Cohorts',
    to: '/admin/cohorts',
    icon: <span className="ic">📊</span>,
  },
  {
    key: 'access',
    label: 'Roles & access',
    to: '/admin/access',
    icon: <span className="ic">🔑</span>,
  },
  {
    key: 'params',
    label: 'Parámetros',
    to: '/admin/params',
    icon: <span className="ic">⚙</span>,
  },
];
